import React from 'react';

const containerStyle = {
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    padding: '24px',
    marginTop: '100px',
    transition: 'all 1s ease-in-out',
    userSelect: 'none',
    maxHeight: '50vh',
    overflowY: 'auto',
    overflowX: 'hidden',
};

const layoutStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '40px',
};

const sectionStyle = {
    flex: 1,
    minWidth: '300px',
    maxHeight: 'calc(50vh - 48px)', // optional: adjust based on layout
    overflowY: 'auto', // enables scroll within column
    paddingRight: '8px', // prevent scrollbar overlapping text
};


const headingStyle = {
    fontSize: '20px',
    fontWeight: '600',
    color: '#1F2937',
    borderBottom: '1px solid #E5E7EB',
    paddingBottom: '8px',
    marginBottom: '16px',
};

const listStyle = {
    paddingLeft: '24px',
    color: '#374151',
    fontSize: '14px',
    lineHeight: '1.75',
};

const subListStyle = {
    paddingLeft: '24px',
    marginTop: '4px',
    marginBottom: '4px',
};

const buttonWrapperStyle = {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    padding: '16px 0',
    textAlign: 'right',
    zIndex: 10,
    borderTop: '1px solid #E5E7EB',
    marginTop: '16px',
};

const buttonStyle = {
    backgroundColor: '#007bff', // blue-600
    color: 'white',
    padding: '10px 24px',
    fontSize: '13px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: '500',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
};





const ScanAndPayOpsFlow = ({ onClose }) => {
    return (
        <div style={containerStyle}>
            <div style={layoutStyle}>
                {/* Left - User Journey */}
                <div style={sectionStyle}>
                    <h4 style={headingStyle}>
                        🚀 User Journey – Cashless Pharmacy Scan and Pay
                    </h4>
                    <ol style={listStyle}>
                        <li>User uploads prescription via the Visit app.</li>
                        <li>System digitizes and validates it to create an auto-cart.</li>
                        <li>Availability and delivery TAT are checked with Apollo/1mg.</li>
                        <li>If unserviceable, Scan and Pay option is enabled.</li>
                        <li>User selects a nearby pharmacy and matches prescription items.</li>
                        <li>
                            User scans QR via Visit app and enters:
                            <ul style={subListStyle}>
                                <li>Pharmacy name</li>
                                <li>Map location (Google Places API)</li>
                                <li>Payment amount</li>
                            </ul>
                        </li>
                        <li>Visit pays on user's behalf using pre-approved credit limit.</li>
                        <li>User collects medicines without out-of-pocket payment.</li>
                        <li>User uploads the pharmacy invoice via the app.</li>
                        <li>Doctor verifies invoice and prescription alignment.</li>
                        <li>If verified, app stays active. If not, app is temporarily blocked.</li>
                        <li>User must resolve invoice queries or pay back the outstanding amount to unblock.</li>
                        <li>Post-verification, app is unblocked for continued usage.</li>
                    </ol>
                </div>

                {/* Right - Ops Triggers */}
                <div style={sectionStyle}>
                    <h4 style={headingStyle}>
                        🛠️ Ops Triggers & Exception Handling
                    </h4>
                    <ol style={listStyle}>
                        <li>
                            <strong>Trigger 1:</strong> Amount entered is ≥ 20% higher than auto-cart estimate.
                            <ul style={subListStyle}>
                                <li><strong>Outcome:</strong> Ops is alerted to validate the difference.</li>
                                <li><strong>Ops Action:</strong> Check dashboard logs, then contact user to understand reason.</li>
                                <li><strong>Scenarios:</strong>
                                    <ul style={subListStyle}>
                                        <li><strong>Substitute Medicines:</strong>
                                            <ul style={subListStyle}>
                                                <li>Approve if valid; else user must update items.</li>
                                            </ul>
                                        </li>
                                        <li><strong>Extra Items:</strong>
                                            <ul style={subListStyle}>
                                                <li>Only prescription items covered.</li>
                                                <li>Personal items billed separately.</li>
                                            </ul>
                                        </li>
                                        <li><strong>Pack Size Change:</strong>
                                            <ul style={subListStyle}>
                                                <li>Approve if it's a larger pack of same medicine.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Trigger 2:</strong> QR code scanning fails.
                            <ul style={subListStyle}>
                                <li><strong>Reason:</strong> QR code is unsupported.</li>
                                <li><strong>Ops Action:</strong> Check dashboard logs and ask user to try a different QR code.</li>
                                <li><strong>User Guidance:</strong> Suggest another QR or a nearby UPI-enabled store.</li>
                            </ul>
                        </li>
                        <li>
                            <strong>Trigger 3:</strong> UPI payment fails or remains pending.
                            <ul style={subListStyle}>
                                <li><strong>Outcome:</strong> Transaction unclear or failed.</li>
                                <li><strong>Ops Action:</strong> Check dashboard logs, guide user to retry or resolve.</li>
                                <li><strong>Scenarios:</strong>
                                    <ul style={subListStyle}>
                                        <li><strong>Failed Payment:</strong>
                                            <ul style={subListStyle}>
                                                <li>Share reason (e.g. invalid UPI ID).</li>
                                                <li>Guide user to retry.</li>
                                            </ul>
                                        </li>
                                        <li><strong>Pending Payment:</strong>
                                            <ul style={subListStyle}>
                                                <li>Ask user to wait 5-10 mins.</li>
                                                <li>Retry with new QR if unresolved.</li>
                                                <li>If wallet debited, escalate to tech.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Trigger 4:</strong> UPI fails and is super escalated.
                            <ul style={subListStyle}>
                                <li><strong>Ops Action:</strong> Check dashboard logs.</li>
                                <li>Validate the prescription link.</li>
                                <li>Arrange invoice manually.</li>
                                <li>Escalate to tech team if valid.</li>
                            </ul>
                        </li>
                    </ol>
                </div>
            </div>

            <div style={buttonWrapperStyle}>
                <button style={buttonStyle} onClick={onClose}>
                    Close Mannual
                </button>
            </div>
        </div>
    );
};

export default ScanAndPayOpsFlow;
